/**
 * Каталог отделки стен — типовой набор, как у планировщиков ремонта: краска двух
 * степеней блеска, шесть рисунков обоев и две декоративные штукатурки.
 * Цвета — нейтральные, «жилые»; любой основной цвет можно поменять у стороны стены.
 * Id — ключи ссылок из слоя отделки, менять нельзя.
 */
import { LayerKind } from "@/shared/plan/layerKind";
import type { CatalogSection } from "../../types";
import { WallFinishKind, WallPattern, type WallFinishCatalogItem } from "./types";

export const finishSection: CatalogSection<WallFinishCatalogItem> = {
	kind: LayerKind.WallFinish,
	label: "Отделка стен",
	canChangeDimensions: false,
	subGroups: ["Краска", "Обои", "Штукатурка"],
	items: [
		{
			id: "paint-matte",
			subGroup: "Краска",
			name: "Краска матовая",
			description: "Глубоко матовая интерьерная краска: ровный цвет без бликов.",
			kind: WallFinishKind.Paint,
			pattern: WallPattern.Solid,
			color: "#eeebe4",
			accent: "#eeebe4",
			repeat: 1000,
			roughness: 0.95,
		},
		{
			id: "paint-satin",
			subGroup: "Краска",
			name: "Краска шелковисто-матовая",
			description: "Моющаяся краска с лёгким шелковистым блеском — для кухни и коридора.",
			kind: WallFinishKind.Paint,
			pattern: WallPattern.Solid,
			color: "#e4ddd0",
			accent: "#e4ddd0",
			repeat: 1000,
			roughness: 0.55,
		},
		{
			id: "wallpaper-stripes",
			subGroup: "Обои",
			name: "Обои «Полоска»",
			description: "Вертикальные полосы разной ширины, рулон 530 мм.",
			kind: WallFinishKind.Wallpaper,
			pattern: WallPattern.Stripes,
			color: "#ece6da",
			accent: "#d5cab6",
			repeat: 530,
			roughness: 0.85,
		},
		{
			id: "wallpaper-rhombus",
			subGroup: "Обои",
			name: "Обои «Ромб»",
			description: "Тонкая ромбическая сетка на светлом фоне.",
			kind: WallFinishKind.Wallpaper,
			pattern: WallPattern.Rhombus,
			color: "#e3e8ea",
			accent: "#aebcc4",
			repeat: 265,
			roughness: 0.85,
		},
		{
			id: "wallpaper-damask",
			subGroup: "Обои",
			name: "Обои «Дамаск»",
			description: "Классические медальоны в шахматном порядке, рулон 530 мм.",
			kind: WallFinishKind.Wallpaper,
			pattern: WallPattern.Damask,
			color: "#e9e0cf",
			accent: "#c8b48e",
			repeat: 530,
			roughness: 0.8,
		},
		{
			id: "wallpaper-geometric",
			subGroup: "Обои",
			name: "Обои «Соты»",
			description: "Геометрический рисунок из шестиугольников — для акцентной стены.",
			kind: WallFinishKind.Wallpaper,
			pattern: WallPattern.Geometric,
			color: "#4a5a66",
			accent: "#6f808c",
			repeat: 265,
			roughness: 0.85,
		},
		{
			id: "wallpaper-linen",
			subGroup: "Обои",
			name: "Обои «Рогожка»",
			description: "Фактура плетёной ткани — спокойный фон почти для любой комнаты.",
			kind: WallFinishKind.Wallpaper,
			pattern: WallPattern.Linen,
			color: "#d6ccb9",
			accent: "#9f917a",
			repeat: 240,
			roughness: 0.95,
		},
		{
			id: "wallpaper-botanical",
			subGroup: "Обои",
			name: "Обои «Листья»",
			description: "Ботанический рисунок: крупные листья на светлом фоне, рулон 530 мм.",
			kind: WallFinishKind.Wallpaper,
			pattern: WallPattern.Botanical,
			color: "#e4e9e0",
			accent: "#8ea689",
			repeat: 530,
			roughness: 0.85,
		},
		{
			id: "plaster-concrete",
			subGroup: "Штукатурка",
			name: "Штукатурка «Бетон»",
			description: "Декоративная штукатурка под архитектурный бетон: пятна и поры.",
			kind: WallFinishKind.Plaster,
			pattern: WallPattern.Concrete,
			color: "#b8b5ae",
			accent: "#9e9a92",
			repeat: 1200,
			roughness: 0.9,
		},
		{
			id: "plaster-silk",
			subGroup: "Штукатурка",
			name: "Штукатурка «Шёлк»",
			description: "Перламутровая штукатурка с мягкими разводами, чуть блестит.",
			kind: WallFinishKind.Plaster,
			pattern: WallPattern.Silk,
			color: "#e6d9c4",
			accent: "#f3eadb",
			repeat: 900,
			roughness: 0.45,
		},
	],
};
